export const USER_TYPE = {
  GENERAL: 'general',
  COLLEGE: 'college',
};
